export default __webpack_public_path__ + "/dist/images/buyer-ai-graphic-optimized.73c478842fb753a813f33f70105b8fec.jpg";